'use strict';

var Params = function Params(dataLength) {
  return function (containerWidth, containerHeight) {
    var padding = {
      top: 10,
      bottom: 60,
      left: 80,
      right: 40
    };
    var barWidth = 30;
    var width = dataLength * barWidth;
    var height = containerHeight - (padding.top + padding.bottom);
    return {
      width: width,
      height: height,
      containerWidth: containerWidth,
      containerHeight: containerHeight,
      padding: padding,
      yNumberOfTicks: 3,
      xAxisShift: 0,
      yAxisShift: 10,
      yAxisLabelShift: 60,
      forceWidth: true
    };
  };
};
module.exports = Params;